import React from 'react'
import PropTypes from 'prop-types'
import RowButton from 'components/atoms/row-button'
import { STATUS } from 'domains/product-colour/constants'
import StatusBadge from 'domains/product-colour/atoms/status-badge'

const actionCellPropTypes = {
  cell: PropTypes.shape({
    row: PropTypes.shape({
      original: PropTypes.object
    })
  })
}

const productColourTableColumns = ({
  handleEnableColour,
  handleDisableColour,
  handleOpenUpdateModal
}) => {
  const StatusCell = (row) => <StatusBadge status={ row.cell.value } />

  const ActionCell = ({ cell: { row } }) => (
    <div className='d-flex'>
      {
        row.original.status == STATUS.ENABLED ?
          <RowButton
            data={ row.original }
            color='danger'
            onClick={ handleDisableColour }
            text='Disable'
          />
          :
          <RowButton
            data={ row.original }
            color='success'
            onClick={ handleEnableColour }
            text='Enable'
          />
      }
      <RowButton
        data={ row.original }
        color='primary'
        onClick={ handleOpenUpdateModal }
        text='Update'
      />
    </div>
  )

  ActionCell.propTypes = actionCellPropTypes

  return (
    [
      {
        Header   : 'Label',
        accessor : 'label'
      },
      {
        Header         : 'Status',
        accessor       : 'status',
        Cell           : StatusCell,
        disableFilters : true
      },
      {
        Header : 'Actions',
        Cell   : ActionCell
      }
    ]
  )
}

export default productColourTableColumns